import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { AboutSection } from '../components/AboutSection';
import { ImpactSection } from '../components/ImpactSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { StoriesSection } from '../components/StoriesSection';
import { TrustSection } from '../components/TrustSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
export function HomePage() {
  return <div className="font-sans bg-warm-ivory min-h-screen w-full selection:bg-sfrr-pink selection:text-white" data-id="element-720">
      <ScrollToTop data-id="element-721" />
      <Header data-id="element-722" />
      <main data-id="element-723">
        <Hero data-id="element-724" />
        <TrustSection data-id="element-725" />
        <AboutSection data-id="element-726" />
        <ImpactSection data-id="element-727" />
        <ProgramsSection data-id="element-728" />
        <StoriesSection data-id="element-729" />
        <NewsletterSection data-id="element-730" />
      </main>
      <Footer data-id="element-731" />
    </div>;
}